import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrophy,
  faLock,
  faMapMarker,
  faLightbulb,
  faGift,
  faCalendar,
  faClock,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import ChallengeTypeIcon from "../organize/ChallengeTypeIcon";
import { useChallengeQuery } from "./Library.state";
import {
  HintsSection,
  LocationSection,
  LocksSection,
  PointsSection,
  RewardsSection,
  TimersSection,
  TimingSection,
  TypeSection,
  VisibilitySection,
} from "./sections";
import { ContentTab } from "../common";

const LibraryChallengeNav = ({ id }) => {
  const useQuery = () => useChallengeQuery(id);
  const {
    hide_answers,
    hints,
    latitude,
    reward_title,
    reward_description,
    starts_at,
    ends_at,
    task_type,
    timer,
    unlock_by_location_radius,
    unlock_by_task_id,
  } = useQuery();

  const tabs = [
    {
      title: (
        <>
          Type <ChallengeTypeIcon task_type={task_type} />
        </>
      ),
      content: <TypeSection useQuery={useQuery} />,
    },
    {
      title: (
        <>
          Points <FontAwesomeIcon icon={faTrophy} />
        </>
      ),
      content: <PointsSection useQuery={useQuery} />,
    },
    ...(!!unlock_by_task_id || !!unlock_by_location_radius
      ? [
          {
            title: (
              <>
                Locks <FontAwesomeIcon icon={faLock} />
              </>
            ),
            content: <LocksSection useQuery={useQuery} />,
          },
        ]
      : []),
    ...(!!latitude
      ? [
          {
            title: (
              <>
                Location <FontAwesomeIcon icon={faMapMarker} />
              </>
            ),
            content: <LocationSection useQuery={useQuery} />,
          },
        ]
      : []),
    ...(!!hints
      ? [
          {
            title: (
              <>
                Hints <FontAwesomeIcon icon={faLightbulb} />
              </>
            ),
            content: <HintsSection useQuery={useQuery} />,
          },
        ]
      : []),
    ...(!!reward_title || !!reward_description
      ? [
          {
            title: (
              <>
                Rewards and Clues <FontAwesomeIcon icon={faGift} />
              </>
            ),
            content: <RewardsSection useQuery={useQuery} />,
          },
        ]
      : []),
    ...(starts_at || ends_at
      ? [
          {
            title: (
              <>
                Timing <FontAwesomeIcon icon={faCalendar} />
              </>
            ),
            content: <TimingSection useQuery={useQuery} />,
          },
        ]
      : []),
    ...(!!timer
      ? [
          {
            title: (
              <>
                Timers <FontAwesomeIcon icon={faClock} />
              </>
            ),
            content: <TimersSection useQuery={useQuery} />,
          },
        ]
      : []),
    ...(!!hide_answers
      ? [
          {
            title: (
              <>
                Visibility <FontAwesomeIcon icon={faEye} />
              </>
            ),
            content: <VisibilitySection useQuery={useQuery} />,
          },
        ]
      : []),
  ];

  return <ContentTab tabs={tabs} horizontal />;
};

export default LibraryChallengeNav;
